export function outstandingTasksMessage(taskNames) {
    return `This application has ${taskNames.length} outstanding task(s):\n` +
        taskNames.map(name => `- ${name}`).join('\n') +
        '\n\nAre you sure you want to approve it?';
}
